export const numberToCurrency = (number, x, currency) => {
  return new Intl.NumberFormat('af', {
    style: 'currency',
    currency: currency ? currency : 'ZAR',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2
  }).format(number);
};
